
































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import axios from "axios";
import BaseVue from "../../../core/BaseVue";
import { Utils } from "@/core/Utils";

@Component({
  name: "forgot-password",
  components: {}
})
export default class ForgotPasswordComponent extends BaseVue {
  /* cedulaMessage: string = "";
  cedulaMask: any = "";
  cedula = "";
  error = false;
  loading = false;
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }

  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }

  get isCedula() {
    return this.cedulaMask ? Utils.isCedula(this.cedulaMask) : false;
  }

  @Watch("cedulaMask")
  onCedulaBlur() {
    this.cedulaMessage = this.isCedula ? "" : "Cédula incorrecta";
  }
  async sendMail() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.loading = true;
        this.cedula = this.cedulaMask.replace(/-/g, "");
        let username = this.cedula;
        axios({
          url: process.env.VUE_APP_API_URL + "authentication/forgotPasswordPsOnline",
          data: { userName: username },
          method: "POST"
        })
          .then(resp => {
            this.$buefy.snackbar.open(
              `Se ha enviado un email al correo del usuario con la cédula especificada, para restablecer la contraseña.`
            );
            this.cedulaMask = null;
            setTimeout(() => this.$validator.errors.clear(), 10);
          })
          .catch(err => {
            this.$buefy.snackbar.open({
              message:
                "Ha ocurrido un inconveniente, realiza el proceso de envio de recuperación de contraseña nuevamente.",
              type: "is-danger",
              position: "is-top",
              actionText: "Ok",
              indefinite: true,
              container: "snackContainer",
              onAction: () => {}
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  } */
}
